import { className } from "utils/strings";
import { ReactComponent as TickIcon } from "components/icons/tick.svg";
import "./buttons.scss";

export const CheckButton = (props: {
  onClick: () => void;
  checked: boolean;
  hint?: string;
}): JSX.Element => {
  const onClick = () => {
    props.onClick();
  };

  return (
    <button
      className={className({
        check: true,
        "rg-button": true,
        "checked": props.checked,
        "unchecked": !props.checked,
      })}
      onClick={onClick}
      title={props.hint}
    >
      {props.checked && <TickIcon />}
    </button>
  );
};
